import React, { useRef } from 'react'
import { ArtworkContent } from 'styles/algolia/artwork'
import { ArtworkItem } from '../../styles'
import ArtworkImage from './Image'
import UploadImage from './Upload'
export default (props: Record<string, any>): React.ReactElement<React.ComponentProps<any>, any> => {
  const artworkRef: Record<string, any> = useRef()
  const { artwork, index } = props
  // const imageContentHeight = parseInt(imageContentWidth / aspectRatio, 10)
  const imageContentHeight = 320
  const uploadImageUrl = '//d3t95n9c6zzriw.cloudfront.net/common/upload-container.png'

  if (artwork === 'upload') {
    return (
      <ArtworkItem
        role='button'
        tabIndex='0'
        key={`upload-${index}`}
        data-type='artworkItem'
        index={`upload-${index}`}
      >
        <div ref={artworkRef}>
          <ArtworkContent itemScope itemType='http://schema.org/ImageObject'>
            <UploadImage
              {...{ ...props, imageContentHeight, uploadImageUrl }}
              data-type='artUpload'
              key={`create-${index}`}
            />
          </ArtworkContent>
        </div>
      </ArtworkItem>
    )
  } else {
    return (
      <ArtworkItem role='button' tabIndex='0' key={`image-${index}`} data-type='artworkItem'>
        <div itemScope itemType='http://schema.org/CreativeWork'>
          <ArtworkContent itemScope itemType='http://schema.org/ImageObject'>
            <ArtworkImage {...{ ...props }} />
          </ArtworkContent>
        </div>
      </ArtworkItem>
    )
  }
}